import { createGlobalStyle } from 'styled-components';
import {
  detectFontFormat,
  getRuntimeFontFamily,
} from 'components/graphicEditor/services/FontsService';

const AppGlobalFonts = createGlobalStyle`
  body {
    ${(props) =>
      props.fonts.map((font) => {
        const fontFamily = getRuntimeFontFamily(font) || 'Unknown';
        const fontUrl = font.font ? encodeURI(font.font) : '';
        const fontFormat = detectFontFormat(font);
        return `
                  @font-face {
                    font-family: '${fontFamily}';
                    src: url(${fontUrl}) format('${fontFormat}');
                    font-display: swap;
                }
              `;
      }).join('')}
  }
`;

export default AppGlobalFonts;
